var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('timeline-card', {
    attrs: {
      "title": _vm.$t('timeLine.PartnerAccidentDetailsTimeLineElement.title'),
      "divider": true
    },
    scopedSlots: _vm._u([_vm.canUpdateReport ? {
      key: "menu",
      fn: function fn() {
        return [_c('partner-report-update-report-dialog', {
          attrs: {
            "config": [_vm.ReportUpdateTabEnum.accident],
            "activityTarget": "accident"
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_vm.showMap ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('PartnerMap', {
    staticClass: "z-index: 0; !important; ",
    attrs: {
      "coordinates": _vm.coordinates,
      "height": 265,
      "colour": "red"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-list', [_c('v-list-item', [_c('copy-clipboard-text', {
    attrs: {
      "icon": "mdi-account-outline",
      "text": _vm.$t(_vm.role)
    }
  })], 1), _c('v-list-item', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('copy-clipboard-text', {
    attrs: {
      "icon": "mdi-calendar-blank-outline",
      "text": _vm.date
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('copy-clipboard-text', {
    attrs: {
      "icon": "mdi-clock-outline",
      "text": _vm.time
    }
  })], 1)], 1)], 1), _c('v-list-item', [_vm.canReadCompany && _vm.addressText ? _c('span', [_c('tooltip', {
    attrs: {
      "text": _vm.$t('views.Setting.isMapShown.description')
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-map-marker-outline")]), _c('a', {
    on: {
      "click": _vm.openMap
    }
  }, [_vm._v(" " + _vm._s(_vm.addressText) + " ")])], 1)], 1) : _c('copy-clipboard-text', {
    attrs: {
      "icon": "mdi-map-marker-outline",
      "text": _vm.locationText
    }
  })], 1), _vm.comment ? _c('v-list-item', [_c('v-textarea', {
    staticClass: "pt-2",
    attrs: {
      "label": _vm.$t('common.nouns.description'),
      "outlined": "",
      "readonly": "",
      "value": _vm.comment,
      "hide-details": "auto",
      "rows": "3"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }